import React, { Component } from 'react';
import './OfflineIndicator.css';

interface OfflineIndicatorState {
  isOnline: boolean;
}

class OfflineIndicator extends Component<{}, OfflineIndicatorState> {
  constructor(props: {}) {
    super(props);
    this.state = {
      isOnline: navigator.onLine,
    };
  }

  componentDidMount() {
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  }

  handleOnline = () => {
    this.setState({ isOnline: true });
  };

  handleOffline = () => {
    this.setState({ isOnline: false });
  };

  render() {
    const { isOnline } = this.state;

    if (isOnline) {
      return null;
    }

    return (
      <div className="offline-indicator">
        <div className="offline-content">
          <span className="offline-icon">📡</span>
          <span className="offline-text">You're offline</span>
        </div>
      </div>
    );
  }
}

export default OfflineIndicator;
